import { useMemo, useState } from "react";
import faqDb from "../../../data/faqDb";
import Button from "../../ui/Button/Button";
import s from "./Faq.module.scss";

function Faq() {
  const items = Array.isArray(faqDb) ? faqDb : (faqDb?.items ?? []);
  const [activeId, setActiveId] = useState(null);

  const active = useMemo(
    () => items.find((x) => x.id === activeId) || null,
    [items, activeId]
  );

  if (!items.length) return null;

  const toggle = (id) => setActiveId((prev) => (prev === id ? null : id));

  const Answer = ({ item }) => (
    <div className={s.answerCard}>
      <h3 className={s.answerTitle}>{item.question}</h3>

      {Array.isArray(item.answer) ? (
        <ul className={s.answerList}>
          {item.answer.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      ) : (
        <p className={s.answerText}>{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className={s.faq} id="faq">
      <div className={`container ${s.container}`}>
        <div className={s.header}>
          <h2 className={s.title}>Часто задаваемые вопросы</h2>
        </div>

        <div className={s.faqContainer}>
          {/* LEFT: вопросы */}
          <ul className={s.list}>
            {items.map((item) => {
              const isActive = item.id === activeId;

              return (
                <li key={item.id} className={s.li}>
                  <button
                    type="button"
                    className={`${s.item} ${isActive ? s.active : ""}`}
                    onClick={() => toggle(item.id)}
                    aria-expanded={isActive}
                  >
                    <span className={s.question}>{item.question}</span>

                    <svg
                      className={`${s.arrow} ${isActive ? s.arrowOpen : ""}`}
                      viewBox="0 0 24 24"
                      width="32"
                      height="32"
                      aria-hidden="true"
                    >
                      <path d="M8 5l10 7-10 7z" fill="currentColor" />
                    </svg>
                  </button>

                  {/* ✅ INLINE ответ (для мобилки) — рендерим только у активного */}
                  {isActive && (
                    <div className={s.answerInline}>
                      <Answer item={item} />
                    </div>
                  )}
                </li>
              );
            })}
          </ul>

          {/* RIGHT: ответ (для десктопа) */}
          <div className={s.answerSide}>
            {active ? <Answer item={active} /> : null}
          </div>
        </div>

        <div className={s.footer}>
          <h3 className={s.footerTitle}>Остались вопросы? Задайте свой – мы ответим!</h3>
          <Button onClick={() => {
            document.querySelector("#order-form")?.scrollIntoView({ behavior: "smooth" });
          }}>Задать вопрос</Button>
        </div>
      </div>
    </section>
  );
}

export default Faq;
